module.exports = __webpack_public_path__ + "static/img/logo.30c70ff.gif";


//////////////////
// WEBPACK FOOTER
// ./static/image/logo.gif
// module id = Zkwq
// module chunks = 12